import { FiltersSettings, Unit } from './types';

export const INITIAL_SECTIONS = {
  status: false,
  invoiceNumber: false,
  productIds: false,
  date: false,
};

export const INITIAL_FILTERS: FiltersSettings = {
  date: {
    type: 'timeRange',
    dateField: 'issue_date',
  },
  status: [],
  invoiceNumber: '',
  productIds: [],
};

export const INITIAL_RELATIVE_DATE_FILTERS: {
  unit: Unit;
  value: number;
} = {
  unit: 'day',
  value: 0,
};

export const INITIAL_ABSOLUTE_DATE_FILTERS: {
  startDate: Date;
  endDate: Date;
} = {
  startDate: null,
  endDate: null,
};
